import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { HR } from 'foundations-components/transitional/components/HR';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { View } from 'foundations-components/transitional/components/View';
// @ts-expect-error untyped file
import { hasRequiredTicketFields } from 'FormsUI/selectors/FormDefinition';
import usePaymentField from 'FormsUI/components/hooks/payment/usePaymentField';
import useTogglePayments from 'FormsUI/components/hooks/payment/useTogglePayments';
import usePaymentPermissions from 'FormsUI/components/hooks/payment/usePaymentPermissions';
import { useFormRoutingContext } from 'FormsUI/components/editor/options/routing/FormRoutingProvider';
import { noPaymentLinksOnForm } from 'FormsUI/utils/PaymentsUtils';
import PaymentToggle from 'FormsUI/components/editor/leftPanel/properties/PaymentToggle';
import PaymentActions from 'FormsUI/components/editor/leftPanel/properties/PaymentActions';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentTogglePosition = styled.span.withConfig({
  displayName: "Payment__PaymentTogglePosition"
})(["position:absolute;right:24px;top:32px;"]);
const PaymentContainer = () => {
  const {
    isPaymentsOn,
    isPaymentsAccordionOpen,
    togglePaymentsAccordion,
    togglePaymentsOn
  } = useTogglePayments();
  const {
    isPaymentsAvailable,
    isPaymentsConfigured,
    isPaymentsPermissionsGranted,
    paymentEligibilityRequestState
  } = usePaymentPermissions();
  const {
    paymentField: {
      options
    },
    removePaymentOption
  } = usePaymentField();
  const isTicketPropertiesEnabled = useSelector(hasRequiredTicketFields);
  const {
    routing: {
      formRoutingExists,
      formRoutingLoading
    }
  } = useFormRoutingContext();
  const loading = formRoutingLoading || !paymentEligibilityRequestState.isSuccessful();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(View, {
      as: "div",
      padding: "600",
      paddingBlockStart: "800",
      marginInlineEnd: "300",
      position: "relative",
      "data-shepherd-id": "payments-accordion",
      children: [/*#__PURE__*/_jsx(AccordionItem, {
        "data-test-id": "payment-accordion",
        open: isPaymentsAccordionOpen,
        onOpenChange: togglePaymentsAccordion,
        title: /*#__PURE__*/_jsx(Fragment, {
          children: /*#__PURE__*/_jsx(Text, {
            marginInlineEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'editor.options.payment.leftEditor.payment'
            })
          })
        }),
        children: /*#__PURE__*/_jsx(PaymentActions, {
          selectedPaymentLinks: options,
          showZeroState: noPaymentLinksOnForm(options),
          onDelete: removePaymentOption
        })
      }), /*#__PURE__*/_jsx(PaymentTogglePosition, {
        children: !loading ? /*#__PURE__*/_jsx(PaymentToggle, {
          shouldShowPaymentsTooltip: isPaymentsAvailable && !isPaymentsConfigured,
          shouldShowPermissionsTooltip: !isPaymentsPermissionsGranted,
          isPaymentLockBadgeShown: !isPaymentsAvailable,
          isTicketPropertiesEnabled: isTicketPropertiesEnabled,
          isFormRoutingEnabled: formRoutingExists,
          isToggled: isPaymentsOn,
          onChange: ({
            target: {
              checked
            }
          }) => togglePaymentsOn(checked)
        }) : /*#__PURE__*/_jsx(LoadingSpinner, {})
      })]
    }), /*#__PURE__*/_jsx(HR, {
      margin: "0"
    })]
  });
};
export default PaymentContainer;